// extracted by mini-css-extract-plugin
export var typingIndicator = "_sg-0";